module.exports = __webpack_public_path__ + "static/media/video.2d93b58c.svg";